'use client'

import { ReactNode } from 'react'

type FooterSmoothScrollLinkProps = {
  children: ReactNode
  targetId: string
  href?: string
  className?: string
}

export default function FooterSmoothScrollLink({ children, targetId, href, className }: FooterSmoothScrollLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const element = document.getElementById(targetId)
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start',
        inline: 'nearest'
      })
    }
  }

  return (
    <a href={href || `#${targetId}`} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
